import { ApplicationExtensionTypes, OrganizationRole } from "../../../utils/appEnums/AppEnums";

export enum ImportAndExportTabs {
    EXPORTS,
    IMPORTS,
    EXPORT_LOG,
    IMPORT_LOG,
    FAILED_IMPORTS,
    DATA_VIEWS,
}

export interface ImportExport {
    id: number;
    providerOrganization: string;
    title: string;
    description: string;
    queryKey: string;
    exportSupported: boolean;
    importSupported: boolean;
    manualProcess: boolean;
    supportedByOrganizationTypes: OrganizationRole[];
}

export interface ExportFilters {
    radioFilters: {
        label: string;
        requestParam: { name: string; value: string };
    }[];
}
/**
 * The backend serves a closed set of import query keys (see `ImportExportTemplateDefinitionConstants.QueryKey.Values`);
 * every one of them is modelled by `QUERY_KEYS` / `ImportCustomDataQueryKeys`, so narrow the shared `string` field here.
 */
export type Import = Omit<ImportExport, "exportSupported" | "queryKey"> & {
    queryKey: QUERY_KEYS | ImportCustomDataQueryKeys;
};

export interface Export extends Omit<ImportExport, "description" | "fileAttachmentId" | "importSupported"> {
    exportFiltration: ExportFilters;
}

export enum FileFormatEnum {
    EXCEL = "EXCEL",
    TSV = "TSV",
    JSON = "JSON",
    CSV = "CSV",
    XLSX = "XLSX",
}
export enum MultivalueFormatEnum {
    JSON = "JSON",
    PIPE = "PIPE",
}
export type FileFormat = "EXCEL" | "TSV" | "JSON" | "CSV";

export type MultivalueFormat = "JSON" | "PIPE";
export interface ExportDToType {
    fileFormat: FileFormat;
    multiValueFormat: MultivalueFormat;
    startDate: string;
    endDate: string;
}

export enum ImportExportTypeKeys {
    SUBMIT_CAMPAIGN_STEPS_ASSIGN_PARTNER_KEY = "submit-campaign-steps-assign-partner", // assign or invite partner step
    PATIENTS_IMPORT_KEY = "patients-import",
    MEMBERS_iMPORT_KEY = "members-import",
    RUNTIME_CARE_GAPS_IMPORT_KEY = "runtime-care-gaps-import-key",
    INSURANCES_IMPORT_KEY = "insurances-import-key",
    PROVIDERS_IMPORT_KEY = "providers-import",
    CONTACT_POINT_STATUS_IMPORT_KEY = "contact-point-status-import",
}

export enum ImportCustomDataQueryKeys {
    PATIENTS_IMPORT = "Patients Import", // open PatientsImportConfigModal
    MEMBERS_IMPORT = "Members Import", // open PatientsImportConfigModal
    RUNTIME_CARE_GAPS_IMPORT = "Runtime Care Gaps Import",
    INSURANCES_IMPORT = "Insurances Import",
    PROVIDERS_IMPORT = "Providers Import",
    CONTACT_POINT_STATUS_IMPORT = "Contact Point Status Import",
}

export enum QUERY_KEYS {
    PATIENTS_IMPORT = "Patients Import", // open PatientsImportConfigModal
    EXPORT_FULFILLMENT_ORDERS = "Export Fulfillment Orders",
    MEMBERS_IMPORT = "Members Import", // open PatientsImportConfigModal
    RUNTIME_CARE_GAPS_IMPORT = "Runtime Care Gaps Import",
    INSURANCES_IMPORT = "Insurances Import",
    PROVIDERS_IMPORT = "Providers Import",
    CONTACT_POINT_STATUS_IMPORT = "Contact Point Status Import",
}

/**
 * File extensions a custom import accepts. Members import additionally accepts CSV (NG-8715);
 * every other custom import is xlsx-only. Single source of truth for the file picker filter,
 * the drop zone and the submit-time validation.
 */
export const getCustomImportAcceptedExtensions = (queryKey: QUERY_KEYS | ImportCustomDataQueryKeys): ApplicationExtensionTypes[] =>
    queryKey === ImportCustomDataQueryKeys.MEMBERS_IMPORT ? [ApplicationExtensionTypes.XLSX, ApplicationExtensionTypes.CSV] : [ApplicationExtensionTypes.XLSX];
